import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

//api
import { KBService } from "../../../../service/kb-service";


const KBFileList = ({reloadList})=>{
    const navigate = useNavigate()
    const [kbFiles, setKbFiles]= useState([])

    useEffect(()=>{
            const fetchKB = ()=>{
                KBService.getAllKBFiles(
                    (data)=>{
                        if (data && Array.isArray(data.results)) {
                            setKbFiles(data.results); 
                        }else{
                            const errorMessage = "La risposta non contiene un array valido di file.";
                            console.error(errorMessage);
                        }
                    },
                    (error)=>{
                        console.error('Errore durante il recupero dei file: ', error);
                    }
                );
            };
            fetchKB();
        },[reloadList])



    return (
            <div className='template__ComponentWrapper'>
                <h3>Lista dei File</h3>
                    <div className="card ">
                        <DataTable value={kbFiles} tableStyle={{ minWidth: '50rem' }} style={{marginRight:'2rem'}}>
                            <Column field="title" header="Titolo"></Column>
                            <Column field="description" header="Descrizione"></Column>
                            <Column
                                header=""
                                body={(rowData) => (
                                    <Button
                                        label="Gestisci"
                                        className="p-button-sm"
                                        onClick={() => {
                                            const kbId = rowData.id;
                                                navigate(`/dashboard/kb/${kbId}`);
                                        }}
                                    />
                                )}
                            ></Column>
                        </DataTable>
                    </div>
                </div>
        )
}

export default KBFileList